import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OrgState } from "./orgTypes";
import { IPortfolioMetadata } from "@pulse-ui/codegen/generated_ts/org_metadata";

const initialState: OrgState = {
  org_id: null,
  display_name: null,
  created: null,
  last_modified: null,
  portfolios: null,
};

const orgSlice = createSlice({
  name: "org",
  initialState,
  reducers: {
    setOrgId: (state, action: PayloadAction<string>) => {
      state.org_id = action.payload;
    },
    clearOrgId: (state) => {
      state.org_id = null;
    },
    setDisplayName: (state, action: PayloadAction<string>) => {
      state.display_name = action.payload;
    },
    clearDisplayName: (state) => {
      state.display_name = null;
    },
    setCreated: (state, action: PayloadAction<string>) => {
      state.created = action.payload;
    },
    clearCreated: (state) => {
      state.created = null;
    },
    setLastModified: (state, action: PayloadAction<string>) => {
      state.last_modified = action.payload;
    },
    clearLastModified: (state) => {
      state.last_modified = null;
    },
    setPortfolios: (state, action: PayloadAction<IPortfolioMetadata[]>) => {
      state.portfolios = action.payload;
    },
    clearPortfolios: (state) => {
      state.portfolios = null;
    },
    clearOrg: (state) => {
      state.org_id = null;
      state.display_name = null;
      state.created = null;
      state.last_modified = null;
      state.portfolios = null;
    },
  },
});

export const {
  setOrgId,
  clearOrgId,
  setDisplayName,
  clearDisplayName,
  setCreated,
  clearCreated,
  setLastModified,
  clearLastModified,
  setPortfolios,
  clearPortfolios,
  clearOrg,
} = orgSlice.actions;

export default orgSlice.reducer;
